import { FC, useMemo } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'

import { CurrencyValue } from '../../currencyValue/CurrencyValue'

import { TRANSLATION_KEYS } from './translations'

import styles from './RetailerFinance.module.scss'

interface IRetailerFinanceProps {
  pyActuals: number | null
  cyPlans: number | null

  fYear?: number
}

export const RetailerFinance: FC<IRetailerFinanceProps> = (props) => {
  const { pyActuals, cyPlans, fYear } = props

  /** ------------------------- Variables ------------------------- */

  const py = useMemo(() => (fYear ? (fYear % 100) - 1 : 0), [fYear])
  const cy = useMemo(() => (fYear ? fYear % 100 : 0), [fYear])

  /** ------------------------- Render ------------------------- */

  return (
    <div className={styles.root}>
      <div className={styles.fieldWrapper}>
        <div className={styles.label}>
          <Translation text={TRANSLATION_KEYS.pyActualsFieldLabel} span />
        </div>
        <div className={styles.value}>
          FY{py} <CurrencyValue value={pyActuals} auto />
        </div>
      </div>
      <div className={styles.fieldWrapper}>
        <div className={styles.label}>
          <Translation text={TRANSLATION_KEYS.cyPlansFieldLabel} span />
        </div>
        <div className={styles.value}>
          FY{cy} <CurrencyValue value={cyPlans} auto />
        </div>
      </div>
    </div>
  )
}
